<template>
    <div class="partner-style-two-area pb-100">
        <div class="container">
            <div class="partner-slides">
                <carousel
                    :autoplay="5000"
                    :settings='settings'
                    :breakpoints='breakpoints'
                >
                    <slide v-for="slide in carouselItems" :key="slide.id">
                        <div class="partner-item-card">
                            <div class="d-inline-block">
                                <img :src="slide.image" alt="partner">
                            </div>
                        </div>
                    </slide>

                    <template #addons>
                    </template>
                </carousel>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { Carousel, Slide  } from 'vue3-carousel';

import 'vue3-carousel/dist/carousel.css';

export default defineComponent ({
    name: 'Partner',
    components: {
        Carousel,
        Slide,
    },
    data: () => ({
        settings: {
            itemsToShow: 1,
            snapAlign: 'center',
        },
        carouselItems: [
            {
                id: 1,
                image: require('../../assets/images/more-home/partner/partner1.svg'),
            },
            {
                id: 2,
                image: require('../../assets/images/more-home/partner/partner2.svg'),
            },
            {
                id: 3,
                image: require('../../assets/images/more-home/partner/partner3.svg'),
            },
            {
                id: 4,
                image: require('../../assets/images/more-home/partner/partner4.svg'),
            },
            {
                id: 5,
                image: require('../../assets/images/more-home/partner/partner5.svg'),
            },
            {
                id: 6,
                image: require('../../assets/images/more-home/partner/partner1.svg'),
            },
            {
                id: 7,
                image: require('../../assets/images/more-home/partner/partner2.svg'),
            },
            {
                id: 8,
                image: require('../../assets/images/more-home/partner/partner3.svg'),
            },
            {
                id: 9,
                image: require('../../assets/images/more-home/partner/partner4.svg'),
            },
            {
                id: 10,
                image: require('../../assets/images/more-home/partner/partner5.svg'),
            },
        ],
        breakpoints: {
            0: {
                itemsToShow: 2,
                snapAlign: 'left',
			},
            576: {
                itemsToShow: 3,
                snapAlign: 'center',
            },
            768: {
                itemsToShow: 4,
                snapAlign: 'center',
            },
            1024: {
                itemsToShow: 4,
                snapAlign: 'center',
            },
            1200: {
                itemsToShow: 5,
                snapAlign: 'center',
            },
        },
    }),
})
</script>